import React from "react";
import Select, { SelectOption } from "@amzn/meridian/select";
import { SelectOptionType } from "./filterOptions";

interface FilterSelectProps {
    label: string;
    value: string;
    options: SelectOptionType[];
    onChange: (value: string) => void;
    disabled?: boolean;
}

export const FilterSelect: React.FC<FilterSelectProps> = ({
    label,
    value,
    options,
    onChange,
    disabled = false,
}) => {
    return (
        <Select label={label} value={value} onChange={onChange} width="12rem" minWidth="12rem">
            {options.map(option => (
                <SelectOption
                    key={option.value}
                    value={option.value}
                    label={option.label}
                    disabled={disabled}
                />
            ))}
        </Select>
    );
};
